import { useState, useEffect } from 'react';
import PartnerInquiryModal from './PartnerInquiryModal';

export default function WhoWeAre() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasAnimated) {
            entry.target.classList.add('animate-in');
            setHasAnimated(true);
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll('.animate-on-scroll');
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [hasAnimated]);

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <PartnerInquiryModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
      
      <section id="who-we-are" className="relative py-12 sm:py-16 lg:py-24 overflow-hidden">
        {/* Full background image */}
        <div 
          className="absolute inset-0 bg-cover bg-center" 
          style={{ backgroundImage: 'url(https://static.readdy.ai/image/57c982531ce74d8992a8785896e0bafd/b29cd53823257777a4fdf96afa65dd27.png)' }}
        ></div>
        <div className="absolute inset-0 bg-black/50"></div>
        
        <div className="relative z-10 w-full">
          {/* Number and label */}
          <div className="animate-on-scroll flex items-center justify-between px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto mb-4 sm:mb-6 lg:mb-8 animate-in">
            <div className="flex items-center text-white">
              <div className="text-2xl sm:text-3xl lg:text-6xl font-bold mr-2 sm:mr-3 lg:mr-6">1</div>
              <div className="w-6 sm:w-8 lg:w-24 h-px bg-white mr-2 sm:mr-3 lg:mr-6"></div>
              <div className="text-xs sm:text-sm lg:text-lg font-light tracking-widest uppercase">Our Story</div>
            </div>
          </div>

          {/* Content on left side */}
          <div className="flex items-center px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto">
            <div className="w-full lg:w-1/2 lg:pr-12">
              <h2 className="animate-on-scroll animate-delay-100 text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-yellow-400 mb-3 sm:mb-4 lg:mb-8 leading-tight animate-in">
                Bucket List Golf
              </h2>
              <p className="animate-on-scroll animate-delay-200 text-sm sm:text-base lg:text-xl text-white/90 mb-3 sm:mb-4 lg:mb-8 leading-relaxed animate-in">
                <span className="text-yellow-400 font-bold text-base sm:text-xl lg:text-2xl">Bucket List Golf</span> was born inside Thousand Greens™ as its unofficial events arm, created to open doors to the courses most golfers only ever see in their dreams.
              </p>
              <p className="animate-on-scroll animate-delay-300 text-sm sm:text-base lg:text-xl text-white/90 mb-3 sm:mb-4 lg:mb-8 leading-relaxed animate-in">
                The <span className="text-yellow-400 font-bold text-base sm:text-xl lg:text-2xl">Bucket List Series</span> is where those dreams come true—intentionally limited, deeply curated days at the world's most iconic venues, giving members the chance to experience golf in its purest, most unforgettable form.
              </p>
              <p className="animate-on-scroll animate-delay-400 text-sm sm:text-base lg:text-xl text-white/90 mb-4 sm:mb-6 lg:mb-8 leading-relaxed animate-in">
                The <span className="text-yellow-400 font-bold text-base sm:text-xl lg:text-2xl">Bucket List Society (BLS)</span> is our growing member community, driven by a shared hunger for discovery, true camaraderie, and friendships forged through the game we love.
              </p>
              <button
                onClick={() => setIsModalOpen(true)}
                className="animate-on-scroll animate-delay-500 bg-yellow-400 text-black px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-bold text-sm sm:text-base lg:text-lg hover:bg-yellow-500 transition-colors whitespace-nowrap cursor-pointer animate-in"
              >
                GET IN TOUCH
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
